<div class="relative h-[100%] "  [@pageLoad]="pageLoadState">
  <div class="gap-[40px] flex flex-col shrink-0 justify-around items-center pl-[64px] pr-[64px] pt-[40px] pb-[40px] bg-[#f8fafdff] w-[100%] h-[100%]  relative">
    <div class="gap-[40px] flex flex-col w-[100%] shrink-0 justify-center items-center self-stretch grow basis-0">
      <div class="gap-[24px] flex flex-col w-full max-w-[1280px] shrink-0 justify-start items-center">
       
        <span class="w-[100%] shrink-0 justify-center items-center self-stretch text-[#111215ff] text-center font-bold font-['archivo'] text-[24px] leading-[29px]">
          {{ upcomingTitle }}
        </span>

        <span
          *ngIf="registrationError"
          class="w-[100%] text-center text-[#e74c3c] font-normal font-['archivo'] text-[16px] leading-[22px]">
          {{ registrationError }}
        </span>
        
        <!-- Horizontal Scrollable Event Cards -->
        <div class="relative w-full flex items-center justify-center gap-[16px]">
          <!-- Loading State -->
          <div *ngIf="isLoading" class="flex-1 flex items-center justify-center py-[60px]">
            <span class="text-[#444955ff] font-normal font-['archivo'] text-[18px] leading-[27px]">
              Loading events...
            </span>
          </div>

          <!-- Error State -->
          <div *ngIf="hasError && !isLoading" class="flex-1 flex flex-col items-center justify-center py-[60px] gap-[16px]">
            <span class="text-[#e74c3c] font-semibold font-['archivo'] text-[18px] leading-[27px]">
              Failed to load events
            </span>
            <NiButton
              variant="outlined"
              color="primary"
              label="Retry"
              [px]="'[24px]'"
              [py]="'[12px]'"
              [rounded]="'[999px]'"
              (onClick)="loadEvents()">
            </NiButton>
          </div>

          <!-- Events List -->
          <ng-container *ngIf="!isLoading && !hasError">
            <NiButton
              *ngIf="events.length > 0"
              variant="plain"
              type="button"
              ariaLabel="View previous events"
              leadingIcon="ChevronRightFilled"
              leadingIconClass="w-[22px] h-[22px] text-[#111215] rotate-180"
              [px]="'[0px]'"
              [py]="'[0px]'"
              [rounded]="'[999px]'"
              [disabled]="!canScrollLeft"
              [styleClass]="
                canScrollLeft
                  ? 'flex-shrink-0 z-20 flex h-[48px] w-[48px] items-center justify-center border border-[#E5E7EB] bg-white text-[#111215] shadow-[0_15px_30px_rgba(17,18,21,0.12)] transition duration-150 ease-in-out hover:shadow-[0_18px_34px_rgba(17,18,21,0.16)]'
                  : 'flex-shrink-0 z-20 flex h-[48px] w-[48px] items-center justify-center border border-[#E5E7EB] bg-white text-[#111215] opacity-40 cursor-not-allowed'
              "
              (onClick)="scrollLeft()">
            </NiButton>
            <div
              #eventsScroll
              class="events-scroll-container flex-1 min-w-0 overflow-x-auto pb-[8px] scroll-smooth [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden">
              <!-- Empty State -->
              <div *ngIf="events.length === 0" [@fadeIn] class="empty-state flex flex-col items-center justify-center py-[60px] w-full gap-[24px]">
                <!-- Animated Calendar Icon -->
                <div class="empty-state-icon-wrapper">
                  <object 
                    type="image/svg+xml" 
                    data="assets/icons/calendar-empty-state.svg" 
                    class="empty-state-icon" 
                    width="120" 
                    height="120"
                    aria-label="No events calendar icon">
                    <!-- Fallback for browsers that don't support object tag -->
                    <img src="assets/icons/calendar-empty-state.svg" alt="No events calendar icon" width="120" height="120" />
                  </object>
                </div>
                
                <!-- Text Content -->
                <div class="flex flex-col items-center gap-[12px]">
                  <span class="empty-state-title text-[#111215ff] font-bold font-['archivo'] text-[22px] leading-[28px]">
                    No Upcoming Events
                  </span>
                  <span class="empty-state-subtitle text-[#444955ff] font-normal font-['archivo'] text-[16px] leading-[24px] text-center max-w-[400px]">
                    There are currently no scheduled events. Check back later for new exciting opportunities!
                  </span>
                </div>

                <!-- Animated Decorative Elements -->
                <div class="empty-state-decorations">
                  <div class="decoration-circle decoration-1"></div>
                  <div class="decoration-circle decoration-2"></div>
                  <div class="decoration-circle decoration-3"></div>
                </div>
              </div>
              <!-- Events Cards -->
              <div *ngIf="events.length > 0" class="events-cards-wrapper gap-[16px] sm:gap-[20px] md:gap-[24px] lg:gap-[28px]">
                <div
                  *ngFor="let event of events; index as i"
                  class="event-card-wrapper"
                  [style.animation-delay]="(i * 0.05) + 's'">
                  <div
                    class="event-card flex flex-col shrink-0 h-full rounded-[16px] bg-white border-[2px] border-[#E5E7EB] transition-all duration-200 ease-out hover:-translate-y-[3px]">
                    <button
                      type="button"
                      (click)="onViewEventClick(event)"
                      (keydown)="onEventKeyDown($event, event)"
                      [attr.aria-label]="'View event: ' + event.title"
                      class="event-card-view flex flex-col w-[100%] flex-1 min-h-0 cursor-pointer text-left bg-transparent border-0 p-0">
                      <!-- Event Image -->
                      <div
                        class="w-[100%] h-[224px] rounded-tl-[16px] rounded-tr-[16px] shrink-0 event-image relative"
                        [class.loaded]="!event.image || isImageLoaded(event.id)"
                        [class.priority]="i === 0"
                        [class.event-image--empty]="!event.image"
                        [style.background-image]="event.image ? ('url(' + event.image + ')') : null"
                        style="background-repeat: no-repeat; background-size: cover; background-position: center;">
                        <div
                          *ngIf="!event.image"
                          class="w-full h-full flex items-center justify-center rounded-tl-[16px] rounded-tr-[16px] bg-[#EEF2F6] text-[#667085] font-['archivo'] text-[16px] font-medium">
                          No image
                        </div>
                        <span
                          *ngIf="getEventCardBadge(event) as badge"
                          class="absolute top-[12px] right-[12px] z-[2] inline-flex items-center rounded-full px-[12px] py-[8px] font-['archivo'] font-semibold text-[14px] leading-[20px] text-white shadow-sm bg-[#2E90FA]">
                          {{ badge.label }}
                        </span>
                      </div>
                      <!-- Event Content -->
                      <div class="event-card-content gap-[16px] flex flex-col w-[100%] flex-1 min-h-0 self-stretch pl-[16px] pr-[16px] pt-[16px]">
                        <div class="event-card-text gap-[8px] flex flex-col w-[100%] flex-1 min-h-[134px] justify-start items-center self-stretch">
                          <span class="event-card-title w-[100%] text-center text-[#111215ff] font-bold font-['archivo'] text-[20px] capitalize leading-[22px] line-clamp-3">
                            {{ event.title }}
                          </span>
                          <p class="event-card-description w-[100%] h-[60px] text-center text-[#444955ff] font-normal font-['archivo'] text-[18px] leading-[27px] break-words line-clamp-2 m-0">
                            {{ event.description }}
                          </p>
                        </div>
                        <span class="event-card-date w-[100%] text-center shrink-0 text-[#444955ff] font-semibold font-['archivo'] text-[18px] leading-[20px]">
                          {{ event.date }}
                        </span>
                      </div>
                    </button>
                    <div class="event-card-footer w-[100%] px-[16px] pb-[16px] mt-[16px]">
                      <NiButton
                        variant="contained"
                        [color]="isEventActive(event) ? 'secondary' : 'primary'"
                        size="[20px]"
                        [label]="getRegisterButtonLabel(event)"
                        [px]="'[24px]'"
                        [py]="'[12px]'"
                        [rounded]="'[999px]'"
                        [w]="'[100%]'"
                        [bg]="isEventActive(event) ? '[#ffffff]' : '[#f26f24ff]'"
                        [textColor]="isEventActive(event) ? '#12B76A' : '#ffffff'"
                        [border]="isEventActive(event) ? '1' : undefined"
                        [borderColor]="isEventActive(event) ? '[#12B76A]' : undefined"
                        [styleClass]="
                          isEventActive(event)
                            ? 'event-card-register-btn flex flex-row items-center justify-center gap-[12px] rounded-[999px] border border-[#12B76A] bg-white text-[#12B76A] font-bold font-[' +
                              `'archivo'] text-[18px] leading-[23px]'`
                            : 'event-card-register-btn flex flex-row items-center justify-center gap-[12px] rounded-[999px] bg-[#f26f24ff] text-[#ffffffff] font-bold font-[' +
                              `'archivo'] text-[18px] leading-[23px]'`"
                        (onClick)="onRegisterAction(event)">
                      </NiButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Right Chevron - Only show when there are events -->
            <NiButton
              *ngIf="events.length > 0"
              variant="plain"
              type="button"
              ariaLabel="View next events"
              leadingIcon="ChevronRightFilled"
              leadingIconClass="w-[22px] h-[22px] text-[#111215]"
              [px]="'[0px]'"
              [py]="'[0px]'"
              [rounded]="'[999px]'"
              [disabled]="!canScrollRight || events.length === 0"
              [styleClass]="
                canScrollRight && events.length > 0
                  ? 'flex-shrink-0 z-20 flex h-[48px] w-[48px] items-center justify-center border border-[#E5E7EB] bg-white text-[#111215] shadow-[0_15px_30px_rgba(17,18,21,0.12)] transition duration-150 ease-in-out hover:scale-105 hover:shadow-[0_18px_34px_rgba(17,18,21,0.16)]'
                  : 'flex-shrink-0 z-20 flex h-[48px] w-[48px] items-center justify-center border border-[#E5E7EB] bg-white text-[#111215] opacity-40 cursor-not-allowed'
              "
              (onClick)="scrollRight()">
            </NiButton>
          </ng-container>
        </div>
      </div>
    </div>

    <!-- Navigation Buttons -->
    <div class="gap-[8px] flex flex-row w-[100%] shrink-0 justify-between items-start self-stretch">
      <NiButton
        variant="outlined"
        color="secondary"
        size="[20px]"
        label="Back"
        leadingIcon="arrowNarrowLeft"
        [px]="'[24px]'"
        [py]="'[16px]'"
        [rounded]="'[999px]'"
        border="1"
        borderColor="[#5BA5F5]"
        bg="transparent"
        (onClick)="onBackClick()"
        [styleClass]="
          'flex flex-row items-center gap-[8px] rounded-[999px] border border-[#5BA5F5] text-[#2E90FA] font-bold font-[' +
          `'archivo'] text-[18px] leading-[23px] line-height-[24px]'`">
      </NiButton>
      <NiButton
        variant="contained"
        color="primary"
        size="[20px]"
        [label]="isSubmitting ? 'Submitting...' : 'Finish'"
        [px]="'[24px]'"
        [py]="'[16px]'"
        [rounded]="'[999px]'"
        bg="[#f26f24ff]"
        textColor="#ffffff"
        [disabled]="isSubmitting"
        (onClick)="onFinishClick()"
        [styleClass]="
          isSubmitting
            ? 'flex flex-row items-center gap-[12px] rounded-[999px] bg-[#f26f24ff] text-[#ffffffff] font-bold font-[' +
              `'archivo'] text-[18px] leading-[23px] px-[32px] py-[12px] opacity-70 cursor-not-allowed'`
            : 'flex flex-row items-center gap-[12px] rounded-[999px] bg-[#f26f24ff] text-[#ffffffff] font-bold font-[' +
              `'archivo'] text-[18px] leading-[23px] px-[32px] py-[12px]'`">
      </NiButton>
    </div>
  </div>
</div>
